import {
    type AsyncComponentOptions,
    type ComponentPublicInstance,
    createApp,
    h,
} from "vue";
import { router } from "./routes";
import { mountReplace } from "./utilities/mount-replace";

export async function loadComp(
    el: string | Element | undefined,
    comp: Parameters<typeof createApp>[0],
    extra: object | null | undefined = null
): Promise<ComponentPublicInstance<any, any, any, any, any>> {
    let propsData: Record<string, unknown> | null = null;
    if (extra != null) {
        if ("propsData" in extra && extra.propsData) {
            propsData = extra.propsData as unknown as Record<string, unknown>;
            delete extra.propsData;
        }
        comp = Object.assign({}, comp, extra);
        extra = null;
    }
    const app = createApp(comp, propsData).use(router);
    if (el) {
        return mountReplace(app, el);
    }
    return app;
}

export async function loadAsyncComponent(
    el: string | Element | undefined,
    comp: AsyncComponentOptions,
    extra: object | null | undefined = null
) {
    const settings = extra == null ? undefined : extra;
    return await loadComp(el, {
        render() {
            return h(comp, settings, []);
        },
    });
}
